<template lang="html">
  <div :class="['pagination-container', klass]">
    <BPagination
      v-model="page"
      :total-rows="paginateData.total_count"
      :per-page="paginateData.per_page"
      :hide-goto-end-buttons="true"
      last-number
      first-number
      @change="pageChange"
      :limit="4"
    >
      <template v-slot:prev-text>
        <div :class="['control arrow-left']">
          <i :class="['si-icon', 'si-caret_left', !paginateData.first_page && 'active']"></i>
        </div>
      </template>
      <template v-slot:next-text>
        <div :class="['control arrow-right']">
          <i :class="['si-icon', 'si-caret_right', !paginateData.last_page && 'active']"></i>
        </div>
      </template>
    </BPagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
    }
  },
  mounted() {
    this.page = parseInt(this.paginateData.page)
  },
  props: ['paginateData', 'klass'],
  methods: {
    pageChange(page) {
      this.$emit('page-change', page)
    }
  }
}
</script>

<style lang="scss">
.pagination-container {
  ul.pagination {
    margin: 0;

    li {
      margin: 0 16px;

      span:focus, button:focus {
        box-shadow: none;
      }

      * {
        color: var(--gray);
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 0.07px;
      }

      button, span.page-link {
        background-color: inherit;
        border: none;
        padding: 0;
        text-align: center;
        width: 100%;
      }

      &.active * {
        color: var(--black);
        background-color: inherit;
        font-weight: 600;
      }

      &:last-child, &:first-child {
        margin: 0;
        flex: 1;
        button {
          width: 100%;
        }
      }
    }

    .control {
      .si-icon {
        font-weight: bold;
        font-size: 18px;
        color: var(--gray187);
        cursor: default;

        &.active {
          color: var(--black);
          cursor: pointer;
        }
      }

      &.arrow-left {
        width: 100%;
        text-align: left;
      }

      &.arrow-right {
        width: 100%;
        text-align: right;
      }
    }
  }
}
</style>
